import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';

interface ChangePasswordDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  password: string;
  setPassword: (value: string) => void;
  confirmPassword: string;
  setConfirmPassword: (value: string) => void;
}

const ChangePasswordDialog: React.FC<ChangePasswordDialogProps> = ({
  open,
  onClose,
  onSave,
  password,
  setPassword,
  confirmPassword,
  setConfirmPassword
}) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Change Password</DialogTitle>
    <DialogContent>
      <TextField
        label="New Password"
        type="password"
        value={password}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Confirm Password"
        type="password"
        value={confirmPassword}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setConfirmPassword(e.target.value)}
        fullWidth
        margin="normal"
      />
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button onClick={onSave} variant="contained">Save</Button>
    </DialogActions>
  </Dialog>
);

export default ChangePasswordDialog; 